import React, { forwardRef, memo } from 'react';

import MuiTypography, { TypographyProps } from '@mui/material/Typography';

import SkeletonLoader from '@components/common/SkeletonLoader';

type WidthValue = number | string;

export interface LoadingTypographyProps extends TypographyProps {
  isLoading?: boolean;
  skeletonWidth?: WidthValue;
  skeletonClassName?: string;
  skeletonWrapClassName?: string;
  skeletonCount?: number;
}

const createWidthStyle = (width?: WidthValue) => {
  if (width === undefined) {
    return undefined;
  }

  if (typeof width === 'number') {
    return { width: `${width}px` };
  }

  return { width };
};

const LoadingTypographyComponent = forwardRef<
  HTMLElement,
  LoadingTypographyProps
>(
  (
    {
      isLoading = false,
      skeletonWidth = '10ch',
      skeletonClassName,
      skeletonWrapClassName,
      skeletonCount,
      className,
      children,
      ...typographyProps
    },
    ref,
  ) => {
    if (isLoading) {
      return (
        <MuiTypography ref={ref} className={className} {...typographyProps}>
          <div style={createWidthStyle(skeletonWidth)}>
            <SkeletonLoader
              className={skeletonClassName}
              classNameWrap={skeletonWrapClassName}
              count={skeletonCount}
            />
          </div>
        </MuiTypography>
      );
    }

    return (
      <MuiTypography ref={ref} className={className} {...typographyProps}>
        {children}
      </MuiTypography>
    );
  },
);

LoadingTypographyComponent.displayName = 'LoadingTypography';

export default memo(LoadingTypographyComponent);
